import { createSelector } from 'reselect';
import { I18NEXT_REDUCER_NAME } from './constants';
import { initialState } from './reducer';
import { getFormattedLanguages } from './_utils/get-formatted-languages';
export var I18nextStorageSelector = function (store) { return store[I18NEXT_REDUCER_NAME] || initialState; };
export var i18nLanguagesListSelector = createSelector([I18nextStorageSelector], function (_a) {
    var languagesList = _a.languagesList;
    return languagesList && languagesList.length
        ? getFormattedLanguages(languagesList)
        : [];
});
export var i18nLanguagesPureListSelector = createSelector([I18nextStorageSelector], function (_a) {
    var languagesList = _a.languagesList;
    return languagesList || [];
});
